export default __webpack_public_path__ + "static/media/project1.2d8f458c.png";